import _ from 'lodash'

function useCommentData({ hasComment, key, id } = {}) {
  // Validación de parámetros
  if (!hasComment || !key) {
    return false
  }

  // Verificar si existe la card
  if (!hasComment.card) {
    return false
  }

  // Verificar si existe la key en la card
  if (!hasComment.card[key]) {
    return false
  }

  // Si se proporciona un id, verificar si existe
  if (id !== undefined) {
    return !hasComment.card[key][id]
  }

  // Si no hay id, verificar si la key tiene contenido
  return !_.isEmpty(hasComment.card[key])
}

export default useCommentData
